var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CareAppListActionFactory } from './action-factory';
var StaffActions = /** @class */ (function (_super) {
    __extends(StaffActions, _super);
    function StaffActions() {
        return _super.call(this, "Staff") || this;
    }
    Object.defineProperty(StaffActions.prototype, "REQUEST_BULK_IMPORT", {
        get: function () {
            return this.type + "[Request] Bulk Import Staff";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StaffActions.prototype, "RESPONSE_SUCCESS_BULK_IMPORT", {
        get: function () {
            return this.type + "[Response][Success] Bulk Import Staff";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StaffActions.prototype, "RESPONSE_FAIL_BULK_IMPORT", {
        get: function () {
            return this.type + "[Response][Fail] Bulk Import Staff";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StaffActions.prototype, "REQUEST_UPDATE_ROLE", {
        get: function () {
            return this.type + "[Request] Update Role";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StaffActions.prototype, "RESPONSE_SUCCESS_UPDATE_ROLE", {
        get: function () {
            return this.type + "[Response][Success] Update Role";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StaffActions.prototype, "RESPONSE_FAIL_UPDATE_ROLE", {
        get: function () {
            return this.type + "[Response][Fail] Update Role";
        },
        enumerable: true,
        configurable: true
    });
    StaffActions.prototype.RequestBulkImport = function (payload) {
        return {
            type: this.REQUEST_BULK_IMPORT,
            payload: payload
        };
    };
    StaffActions.prototype.ResponseSuccessBulkImport = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_BULK_IMPORT,
            payload: payload
        };
    };
    StaffActions.prototype.ResponseFailBulkImport = function (payload) {
        return {
            type: this.RESPONSE_FAIL_BULK_IMPORT,
            payload: payload
        };
    };
    StaffActions.prototype.RequestUpdateRole = function (payload) {
        return {
            type: this.REQUEST_UPDATE_ROLE,
            payload: payload
        };
    };
    StaffActions.prototype.ResponseSuccessUpdateRole = function (payload) {
        return {
            type: this.RESPONSE_SUCCESS_UPDATE_ROLE,
            payload: payload
        };
    };
    StaffActions.prototype.ResponseFailUpdateRole = function (payload) {
        return {
            type: this.RESPONSE_FAIL_UPDATE_ROLE,
            payload: payload
        };
    };
    return StaffActions;
}(CareAppListActionFactory));
export var Staff = new StaffActions();
